/* eslint-disable @typescript-eslint/no-unused-vars */
// import moment from 'moment-timezone';

import { observer } from "mobx-react-lite";
import { useLocalization } from "@progress/kendo-react-intl";
import { useStores } from "src/stores";
import { default as React, useEffect, useState } from "react";
import { useServices } from "src/services";
import { Grid, GridCellProps, GridColumn } from "@progress/kendo-react-grid";
import { Button } from "@progress/kendo-react-buttons";
import { useHistory } from "react-router";
import hashid from "../utils/hashid";
import moment from "moment";
import capitalize from "src/utils/capitalize";
// @ts-ignore
import PrivacyBanner from "react-ford-ccpa-banner";
import { Loader } from "@progress/kendo-react-indicators";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { Field, Form, FormElement } from "@progress/kendo-react-form";
import { Error } from "@progress/kendo-react-labels";
import { NumericTextBox } from "../components/form/NumericTextBox";
import { Input } from "../components/form/Input";
import { Upload } from "../components/form/Upload";
import { DatePicker, TimePicker } from "@progress/kendo-react-dateinputs";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import {
  UploadFileInfo,
  UploadOnAddEvent,
  UploadOnProgressEvent,
  UploadOnRemoveEvent,
  UploadOnStatusChangeEvent,
} from "@progress/kendo-react-upload";

import "../styles/_events.scss";

// import { houseAfternoon, houseEvening, houseMorning, houseNight, houseNoon, houseSunrise } from '../assets/images/houseImages';

const EventsScreen = () => {
  const localizationService = useLocalization();
  const { language } = localizationService;

  const { ui, login } = useStores();
  const { d4ur } = useServices();
  let history = useHistory();

  const [hasAnEvent, setHasAnEvent] = useState<boolean>(false);

  useEffect(() => {
    setHasAnEvent(false);

    for (const event of ui.events) {
      if (event.status !== "ineligible" && event.status !== "cancelled") {
        setHasAnEvent(true);
        break;
      }
    }
  }, [ui.events]);

  const processEvents = (events: D4UREvent[]): D4UREvent[] => {
    // A failed request resolves with the API's error object rather than a list.
    if (!Array.isArray(events)) return [];
    return events.map((e) => {
      const { start_date, eligibility_custom_data, status } = e;
      const { requested_date, requested_month } = JSON.parse(
        eligibility_custom_data || "{}"
      );

      switch (status) {
        case "new":
          e.sort_status = 0;
          break;

        case "review":
          e.sort_status = 1;
          break;

        case "eligible":
          e.sort_status = 2;
          break;

        case "planning":
          e.sort_status = 3;
          break;

        case "approved":
          e.sort_status = 4;
          break;

        case "in progress":
          e.sort_status = 5;
          break;

        case "event ending":
          e.sort_status = 6;
          break;

        case "event ended":
          e.sort_status = 7;
          break;

        case "ineligible":
          e.sort_status = 99;
          break;

        case "revise":
          e.sort_status = 100;
          break;

        case "cancelled":
          e.sort_status = 101;
          break;

        default:
          e.sort_status = 999;
          break;
      }

      if (start_date) {
        e.sort_date = start_date;
        e.display_date = moment(start_date).format("ddd MMM Do yyyy");
      } else if (requested_date) {
        e.sort_date = requested_date;
        e.display_date = moment(requested_date).format("ddd MMM Do yyyy");
      } else {
        e.sort_date = moment(
          `${requested_month} 1 ${ui.currentSeason.start_date}`
        );
        e.display_date = requested_month;
      }

      return e;
    });
  };

  const [processing, setProcessing] = useState<boolean>(true);
  const [twoFAEmailSent, setTwoFAEmailSent] = useState<boolean>(false);
  const [dialogDisplayed, setDialogDisplayed] = useState<boolean>(false);
  const [twoFA_DialogDisplayed, setTwoFA_DialogDisplayed] =
    useState<boolean>(false);
  const [eventDetailsDialogDisplayed, setEventDetailsDialogDisplayed] =
    useState<boolean>(false);
  const [loadingEventDetails, setLoadingEventDetails] = useState<boolean>(false);
  const [files, setFiles] = useState<Array<UploadFileInfo>>([]);
  const [formError, setFormError] = useState<string>();
  const [twoFAError, setTwoFAError] = useState<string>();
  const [selectedEvent, setSelectedEvent] = useState<number>(0);
  const [selectedEventData, setSelectedEventData] = useState<D4UREvent | null>(null);
  const [isEditing, setIsEditing] = useState<boolean>(false);
  const [hasChanges, setHasChanges] = useState<boolean>(false);
  const [editedData, setEditedData] = useState<any>({});
console.log('selectedEventData', selectedEventData);

  const locationTypeOptions = ["The School", "The Dealership", "Other"];

  const ref: any = React.useRef(null);

  const handleOnWheel = (event: any) => {
    event.stopPropagation();
  };

  React.useEffect(() => {
    ref?.current?.element.addEventListener("wheel", handleOnWheel);

    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      ref?.current?.element.removeEventListener("wheel", handleOnWheel);
    };
  });

  useEffect(() => {
    d4ur.getAccount();
    ui.setIsGettingEvents(true);
    d4ur.checkWaitlist().then((res: any) => {
      if (res.result.events_full === 1) {
        ui.setEventsFull(true);
      }
    });
    d4ur.checkRequest().then((ret) => {
      if ((ret as D4URFetchResult).response.status === 200) {
        ui.setIsApprovedDealer(true);
      } else {
        ui.setIsApprovedDealer(false);
      }
    });
    d4ur.getEvents().then((ret) => {
      const processedEvents = processEvents(
        (ret as D4URFetchResult).result || []
      );
      ui.setIsGettingEvents(false);

      ui.setEvents(processedEvents);
      setProcessing(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleEventRequestButton = () => {
    if (ui.isApprovedDealer) {
      history.push("/eligibility");
    } else {
      alert(
        localizationService.toLanguageString(
          "custom.notApprovedDealer",
          "notApprovedDealer"
        )
      );
    }
  };

  const handleJoinWaitlistButton = () => {
    const dealerId = login.dealer?.dealer_id;
    const dealerEmail = login.dealer?.contact_email;
    if (ui.isApprovedDealer && dealerId && dealerEmail) {
      return d4ur.joinWaitlist(dealerId, dealerEmail).then((res: any) => {
        if (res.result.success) {
          history.go(0);
          alert("Successfully joined waitlist.");
        } else {
          alert(
            "There was an error joining the waitlist. Please contact support at hello@driveforyourcommunity.com."
          );
        }
      });
    } else {
      alert(
        "Dealer not approved or dealer_id not found. Please contact support at hello@driveforyourcommunity.com."
      );
    }
  };

  const handleSend2FAEmail = async () => {
    setTwoFAEmailSent(false);
    const contactEmail = (login.dealer as Dealer).contact_email;
    return d4ur
      .send2FAEmail(contactEmail)
      .then(async (res: any) => {
        ui.setReceivedCode(res.result.code);
        setTwoFAEmailSent(true);
        return;
      })
      .catch((e) => {
        console.log("handleSend2FAEmail Error", e);
        ui.setReceivedCode("");
        login.setTwoFACode("");
        setTwoFAEmailSent(false);
        setTwoFAError(e);
        return;
      });
  };

  const onSubmit2FACode = React.useCallback(
    async (dataItem) => {
      const { entered_code } = dataItem;
      const [decodedTimestamp] = await hashid.decode(
        "lcc_2fa_code",
        ui.receivedCode
      );
      if (
        entered_code === ui.receivedCode &&
        moment(decodedTimestamp).isSame(moment(), "day")
      ) {
        login.setTwoFACode(ui.receivedCode);
        history.push(`/respondents/${ui.selectedEventID}`);
      } else {
        console.log("This code is invalid or has expired, please try again");
        setTwoFAError(
          "This code is invalid or has expired, please try again or click here to request a new code."
        );
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [history]
  );

  const doMagicLink = (event_id: string) => {
    d4ur.getEventToken(event_id).then((tokenResult) => {
      const { token, url} = (tokenResult as D4URFetchResult).result;
      setTimeout(() => {
        window.location.href = `${url}/auto_login/${token}`;
      });
    });
  };

  const isEventEditable = (eventData: D4UREvent) => {
    if (!eventData.start_date) return false;
    const eventStartDate = moment(eventData.start_date);
    const dayBeforeEvent = eventStartDate.clone().subtract(1, 'day').endOf('day');
    const today = moment();
    return today.isSameOrBefore(dayBeforeEvent);
  };

  const handleViewEventDetails = async (event_id: number) => {
    setLoadingEventDetails(true);
    setEventDetailsDialogDisplayed(true);
    setSelectedEventData(null);
    setIsEditing(false);
    setHasChanges(false);
    setEditedData({});

    try {
      const response: any = await d4ur.getEventDetails(event_id);
      console.log('[EventsScreen] Full API response:', response);
      console.log('[EventsScreen] Response.result:', response?.result);
      console.log('[EventsScreen] Response.result.event:', response?.result?.event);

      if (response?.result?.event) {
        console.log('[EventsScreen] Setting event data:', response.result.event);
        setSelectedEventData(response.result.event);
        // Initialize edited data with current event data
        setEditedData({
          start_time: response.result.event.start_time ? moment(response.result.event.start_time, 'HH:mm:ss').toDate() : null,
          end_time: response.result.event.end_time ? moment(response.result.event.end_time, 'HH:mm:ss').toDate() : null,
        });
      } else if (response?.result?.error) {
        console.error('[EventsScreen] Error fetching event details:', response.result.error);
        alert('Failed to load event details. Please try again.');
        setEventDetailsDialogDisplayed(false);
      } else {
        console.warn('[EventsScreen] Unexpected response structure:', response);
        alert('Failed to load event details. Please try again.');
        setEventDetailsDialogDisplayed(false);
      }
    } catch (error) {
      console.error('[EventsScreen] Error fetching event details:', error);
      alert('Failed to load event details. Please try again.');
      setEventDetailsDialogDisplayed(false);
    } finally {
      setLoadingEventDetails(false);
    }
  };
  const onAdd = (event: UploadOnAddEvent) => {
    console.log("onAdd: ", event.affectedFiles);

    setFiles(event.newState);
  };

  const onRemove = (event: UploadOnRemoveEvent) => {
    console.log("onRemove: ", event.affectedFiles);

    setFiles(event.newState);
  };

  const onProgress = (event: UploadOnProgressEvent) => {
    console.log("onProgress: ", event.affectedFiles);

    setFiles(event.newState);
  };

  const onStatusChange = (event: UploadOnStatusChangeEvent) => {
    console.log("onStatusChange: ", event.affectedFiles);

    setFiles(event.newState);
  };

  const onSubmitReimbursement = React.useCallback(
    async (dataItem) => {
      setProcessing(true);
      const [selectedFile] = files;
      const rawFile =
        selectedFile && selectedFile.getRawFile && selectedFile.getRawFile();
      if (rawFile) {
        dataItem.event_reimbursement_file = rawFile;
      }
      dataItem.event_id = selectedEvent;

      console.log("dataItem", dataItem);

      const call: any = await d4ur.saveReimbursement(dataItem);
      if (call.result.errors) {
        console.log("[EventPlanningFormScreen]", "Reimbursement Request Error");
        setFormError(call.result.errors.join("\n"));
        setProcessing(false);
      } else {
        console.log(
          "[EventPlanningFormScreen]",
          "Reimbursement Request created"
        );
        history.go(0);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [d4ur, files, history]
  );

  const EventStatusCell = (props: GridCellProps) => {
    const { status } = props.dataItem as D4UREvent;

    return <td>{capitalize(status || "")}</td>;
  };

  const EventActionsCell = (props: GridCellProps) => {
    const { event_id, event_request_id, status, reimbursement_requested } =
      props.dataItem as D4UREvent;
    const eventData = props.dataItem as D4UREvent;

    // Check if event is within 30 days of start date or has already started
    const isEventPortalAvailable = () => {
      if (!eventData.start_date) return false;
      const eventStartDate = moment(eventData.start_date).startOf('day');
      const today = moment().startOf('day');
      const daysUntilEvent = eventStartDate.diff(today, 'days');
      // Available if: event has started (daysUntilEvent <= 0) OR event is within 30 days (0-30 days away)
      return daysUntilEvent <= 30;
    };

    return (
      <td className="action_cell_container">
        {["eligible", "planning", "revise"].includes(status!) && (
          <Button
            className="standard_btn"
            // onClick={() => props.enterEdit(props.dataItem)}
            onClick={() => {
              if (event_id) {
                history.push(`/event/${event_id}`);
              } else {
                history.push(`/eventRequest/${event_request_id}`);
              }
            }}
          >
            Edit
          </Button>
        )}
        {/* Submitted and awaiting PHQ approval. 'eligible'/'planning'/'revise' are
            excluded on purpose: those are waiting on the dealer, not on review,
            and get an Edit button above. */}
        {["new", "review"].includes(status!) && (
          <p className="review_pending_text">Review Pending</p>
        )}
        {["approved", "in progress", "event ending", "event ended"].includes(
          status!
        ) && (
          <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
            <Button
              className="standard_btn"
              onClick={() => {
                if (event_id) {
                  handleViewEventDetails(event_id);
                }
              }}
            >
              View Event Details
            </Button>
            {/* <Button
              className="standard_btn view_details_btn"
              disabled={!isEventPortalAvailable()}
              onClick={() => {
                if (isEventPortalAvailable()) {
                  doMagicLink(`${event_id}`);
                }
              }}
            >
              Event Portal Git Test
            </Button> */}
            <p
              className="small_events_btn"
              style={{ 
                opacity: isEventPortalAvailable() ? 1 : 0.5,
                cursor: isEventPortalAvailable() ? 'pointer' : 'not-allowed'
              }}
              onClick={() => {
                if (isEventPortalAvailable()) {
                  doMagicLink(`${event_id}`);
                }
              }}
            >
              Event Portal
            </p>
          </div>
        )}
        {/* {["approved", "in progress", "event ending"].includes(status!) && (
          <Button
            className="k-button k-primary"
            style={{ marginLeft: "10px", }}
            onClick={async () => {
              // if already authenticated today, proceed.
              if (login.twoFACode) {
                const [decodedTimestamp] = await hashid.decode('lcc_2fa_code', login.twoFACode);
                if (moment(decodedTimestamp).isSame(moment(), 'day')) {
                  console.log('Already authenticated today - proceeding to respondents page')
                  history.push(`/respondents/${event_id}`);
                }
                console.log('Not authenticated today - proceeding to 2FA.')
                return;
              }
              ui.setSelectedEventID(event_id!)
              setTwoFA_DialogDisplayed(true);
            }}
          >
            View Respondents
          </Button>
        )} */}
        {/* {["donation approved"].includes(status!) && !reimbursement_requested && (
          <Button
            className="k-button k-primary"
            style={{ marginLeft: "10px" }}
            onClick={() => {
              setSelectedEvent(event_id!);
              setDialogDisplayed(true);
            }}
          >
            Start Reimbursement
          </Button>
        )} */}
      </td>
    );
  };

  // const generateHelperText = () => {
  //   if (ui.eventsFull && !hasAnEvent && !login.dealer?.invited_off_waitlist) {
  //     return (
  //       <p className="waitlist-disclaimer">Click this button to be placed on the waitlist. You will receive an email confirmation with more details.</p>
  //     );
  //   } else if (ui.eventsFull && login.dealer?.invited_off_waitlist && !hasAnEvent) {
  //     return (
  //       <p className="waitlist-disclaimer">You have been invited off of the waitlist, please click the button above to request your event.</p>
  //     );
  //   }
  //   return (
  //     <p>Eligible dealers can host one (1) Drive 4 UR Community event in the 2025 session.</p>
  //   );
  // };

  // const renderEventRequestButton = (dealer: Dealer) => {
  //   if (!dealer.waitlistOpen) {
  //     if (dealer.canRequest) {
  //       return <Button className="standard_btn wide" onClick={handleEventRequestButton}>Request New Event</Button>;
  //     } else if (!dealer.canRequest || hasAnEvent) {
  //       return <Button className="standard_btn wide" disabled>Request New Event</Button>;
  //     }
  //   } else if (dealer.waitlistOpen && !dealer.waitlistClosed) {
  //     if (!login.dealer?.waitlisted) {
  //       return <Button className="standard_btn wide" onClick={handleJoinWaitlistButton}>Join Waitlist</Button>;
  //     } else if (login.dealer?.waitlisted && !login.dealer?.invited_off_waitlist) {
  //       return <Button className="standard_btn wide" disabled>Waitlist Joined</Button>;
  //     } else if (login.dealer?.invited_off_waitlist) {
  //       return <Button className="standard_btn wide" onClick={handleEventRequestButton}>Request New Event</Button>;
  //     }
  //   } else if (dealer.waitlistClosed && !login.dealer?.invited_off_waitlist) {
  //     return <Button className="standard_btn wide" disabled>Not Accepting Requests</Button>;
  //   } else if (dealer.waitlistClosed && login.dealer?.invited_off_waitlist) {
  //     return <Button className="standard_btn wide" onClick={handleEventRequestButton}>Request New Event</Button>;
  //   }
  // };

  // const generateHelperText = (dealer: Dealer) => {
  //   if (!dealer.waitlistOpen) {
  //     if (dealer.canRequest) {
  //      return <p className="waitlist-disclaimer">Eligible dealers can host one (1) Drive 4 UR Community event in the 2025 session.</p>
  //     } else if ((!dealer.canRequest || hasAnEvent) && !dealer.isEarlyEnrollment) {
  //       return null
  //     } else if (!dealer.canRequest && dealer.isEarlyEnrollment) {
  //       return <p className="waitlist-disclaimer">Please check back during general enrollment to request an event.</p>
  //     }
  //   } else if (dealer.waitlistOpen && !dealer.waitlistClosed) {
  //     if (!login.dealer?.waitlisted) {
  //       return <p className="waitlist-disclaimer">Click this button to be placed on the waitlist. You will receive an email confirmation with more details.</p>
  //     } else if (login.dealer?.waitlisted && !login.dealer?.invited_off_waitlist) {
  //       return null
  //     } else if (login.dealer?.invited_off_waitlist) {
  //       return <p className="waitlist-disclaimer">You have been invited off of the waitlist, please click the button above to request your event.</p>
  //     }
  //   } else if (dealer.waitlistClosed && !login.dealer?.invited_off_waitlist) {
  //     return <p className="waitlist-disclaimer">Event requests are now closed for the season.</p>
  //   } else if (dealer.waitlistClosed && login.dealer?.invited_off_waitlist) {
  //     return <p className="waitlist-disclaimer">You have been invited off of the waitlist, please click the button above to request your event.</p>
  //   }
  // };

  // Define an enum for helper text states
  enum HelperTextState {
    ELIGIBLE_DEALER = "Eligible dealers can host one (1) Drive 4 UR Community event in the 2025 session.",
    JOIN_WAITLIST = "Click this button to be placed on the waitlist. You will receive an email confirmation with more details.",
    INVITED_OFF_WAITLIST = "You have been invited off of the waitlist, please click the button above to request your event.",
    SEASON_CLOSED = "Event requests are now closed for the season.",
    EARLY_ENROLLMENT = "Please check back during general enrollment (Wednesday, May 21 at 1PM EST) to request an event.",
    ALREADY_REQUESTED = "You have already requested or have an active event for this season.",
    NOT_YET_OPEN = "Enrollment has not yet opened for this season",
  }

  // Define a type for helper text configuration
  interface HelperTextConfig {
    text: string | null;
  }

  // Update the getHelperTextConfig function to include the new case
  const getHelperTextConfig = (dealer: Dealer): HelperTextConfig => {
    if (!dealer) {
      return { text: null };
    }
    // If user has an approved event, don't show any helper text
    if (hasAnEvent) {
      return { text: null };
    }

    // Case 1: Regular enrollment period
    if (!dealer.waitlistOpen) {
      if (dealer.canRequest) {
        // return { text: HelperTextState.ELIGIBLE_DEALER };
        return { text: null };
      }
      if (dealer.isEarlyEnrollment) {
        return { text: HelperTextState.EARLY_ENROLLMENT };
      }
      if (!dealer.canRequest && !hasAnEvent && !dealer.isEarlyEnrollment) {
        return { text: HelperTextState.NOT_YET_OPEN };
      }
      if (!dealer.canRequest || hasAnEvent) {
        return { text: HelperTextState.ALREADY_REQUESTED };
      }
    }

    // Case 2: Waitlist period
    if (!dealer.waitlistClosed) {
      if (dealer.invited_off_waitlist) {
        // return { text: HelperTextState.INVITED_OFF_WAITLIST };
        return { text: null };
      }
      if (dealer.waitlisted) {
        return { text: null }; // No helper text needed when already on waitlist
      }
      // ADD THIS BACK !!
      // return { text: HelperTextState.JOIN_WAITLIST };
      return { text: null };
    }

    // Case 3: Closed period
    if (dealer.invited_off_waitlist) {
      // return { text: HelperTextState.INVITED_OFF_WAITLIST };
      return { text: null };
    }
    if (dealer.waitlisted) {
      return { text: null }; // No helper text needed when already on waitlist
    }
    // return { text: HelperTextState.SEASON_CLOSED };
    return { text: null };
  };

  // Simplified render function
  const generateHelperText = (dealer: Dealer) => {
    const config = getHelperTextConfig(dealer);

    return config.text ? (
      <p className="waitlist-disclaimer">{config.text}</p>
    ) : null;
  };

  // First, define an enum for button states
  enum ButtonState {
    REQUEST_EVENT = "Request New Event",
    // JOIN_WAITLIST = "Join Waitlist",
    JOIN_WAITLIST = "Join Waitlist",
    WAITLIST_JOINED = "Waitlist Joined",
    NOT_ACCEPTING = "Not Accepting Requests",
  }

  // Define a type for button configuration
  interface ButtonConfig {
    text: string;
    disabled: boolean;
    onClick?: () => void;
  }

  // Separate function to get button configuration
  const getButtonConfig = (dealer: Dealer): ButtonConfig => {
    if (!dealer) {
      return {
        text: "Dealer Not Logged In",
        disabled: true,
      };
    }
    // If user has an active event (not cancelled or ineligible), disable all actions
    if (hasAnEvent) {
      return {
        text: ButtonState.REQUEST_EVENT,
        disabled: true,
      };
    }

    // Case 1: Regular enrollment period
    if (!dealer.waitlistOpen) {
      return {
        text: ButtonState.REQUEST_EVENT,
        // ADD THIS BACK !!
        disabled: !dealer.canRequest,
        // disabled: true,
        onClick: dealer.canRequest ? handleEventRequestButton : undefined,
      };
    }

    // Case 2: Waitlist period or closed with existing waitlist status
    if (!dealer.waitlistClosed || dealer.waitlisted) {
      if (dealer.invited_off_waitlist) {
        return {
          text: ButtonState.REQUEST_EVENT,
          // ADD THIS BACK !!
          disabled: false,
          // disabled: true,
          onClick: handleEventRequestButton,
        };
      }

      if (dealer.waitlisted) {
        return {
          text: ButtonState.WAITLIST_JOINED,
          disabled: true,
        };
      }

      return {
        text: ButtonState.JOIN_WAITLIST,
        // ADD THIS BACK !!
        disabled: false,
        // disabled: true,
        onClick: handleJoinWaitlistButton,
      };
    }

    // Case 3: Closed period (only reaches here if not waitlisted)
    return {
      text: dealer.invited_off_waitlist
        ? ButtonState.REQUEST_EVENT
        : ButtonState.NOT_ACCEPTING,
      disabled: !dealer.invited_off_waitlist,
      // ADD THIS BACK !!
      // disabled: true,
      onClick: dealer.invited_off_waitlist
        ? handleEventRequestButton
        : undefined,
    };
  };

  // Simplified render function
  const renderEventRequestButton = (dealer: Dealer) => {
    const config = getButtonConfig(dealer);

    // TODO: Remove this block to enable the Request Event button for launch
    // const forceDisabled = true;
    // END TODO

    return (
      <Button
        className="standard_btn wide"
        disabled={config.disabled}
        onClick={config.onClick}
      >
        {config.text}
      </Button>
    );
  };

  return (
    <>
      {eventDetailsDialogDisplayed && (
        <Dialog
          title="Event Details"
          onClose={() => setEventDetailsDialogDisplayed(false)}
          width="750px"
          style={{ 
            '--kendo-dialog-titlebar-bg': '#00095B',
            '--kendo-dialog-titlebar-text': '#FFFFFF'
          } as React.CSSProperties}
        >
          {loadingEventDetails ? (
            <div style={{ textAlign: "center", padding: "40px" }}>
              <Loader type="infinite-spinner" size="large" />
              <p>Loading event details...</p>
            </div>
          ) : selectedEventData ? (
          <div style={{ padding: '20px', backgroundColor: '#F5F5F5', maxHeight: '70vh', overflowY: 'auto' }}>
            {/* Basic Information Section */}
            <div style={{ 
              backgroundColor: '#FFFFFF',
              borderRadius: '8px',
              padding: '15px',
              marginBottom: '15px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}>
              {/* Edit Button */}
              {selectedEventData && isEventEditable(selectedEventData) && (
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '15px' }}>
                  <Button
                    primary={!isEditing}
                    onClick={() => {
                      if (isEditing) {
                        // Cancel editing - reset to original data
                        setEditedData({
                          start_time: selectedEventData.start_time ? moment(selectedEventData.start_time, 'HH:mm:ss').toDate() : null,
                          end_time: selectedEventData.end_time ? moment(selectedEventData.end_time, 'HH:mm:ss').toDate() : null,
                        });
                        setHasChanges(false);
                      }
                      setIsEditing(!isEditing);
                    }}
                    style={{
                      backgroundColor: isEditing ? '#ccc' : '#00095B',
                    }}
                  >
                    {isEditing ? 'Cancel' : 'Edit'}
                  </Button>
                </div>
              )}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                <div>
                  <div style={{ 
                    fontSize: '12px', 
                    color: '#666', 
                    fontWeight: 600, 
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    marginBottom: '8px' 
                  }}>
                    Dealer Name
                  </div>
                  <div style={{ fontSize: '16px', color: '#333', fontWeight: 500 }}>
                    {login.dealer?.dealer_name || 'N/A'}
                  </div>
                </div>
                <div>
                  <div style={{ 
                    fontSize: '12px', 
                    color: '#666', 
                    fontWeight: 600, 
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    marginBottom: '8px' 
                  }}>
                    Event Date
                  </div>
                  <div style={{ fontSize: '16px', color: '#333', fontWeight: 500 }}>
                    {selectedEventData.start_date ? moment(selectedEventData.start_date).format('MMM D, YYYY') : 'N/A'}
                  </div>
                </div>
              </div>
              
              {/* Time Fields */}
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px', marginTop: '15px' }}>
                <div>
                  <div style={{ 
                    fontSize: '12px', 
                    color: '#666', 
                    fontWeight: 600, 
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    marginBottom: '8px' 
                  }}>
                    Event Start Time
                  </div>
                  {isEditing && isEventEditable(selectedEventData) ? (
                    <TimePicker
                      value={editedData.start_time}
                      onChange={(e) => {
                        setEditedData({...editedData, start_time: e.value});
                        setHasChanges(true);
                      }}
                      format="h:mm a"
                    />
                  ) : (
                    <div style={{ fontSize: '16px', color: '#333', fontWeight: 500 }}>
                      {selectedEventData.start_time ? moment(selectedEventData.start_time, 'HH:mm:ss').format('h:mm A') : 'N/A'}
                    </div>
                  )}
                  
                  {/* Save Button for Time Editing */}
                  {isEditing && isEventEditable(selectedEventData) && (
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '15px' }}>
                      {/* Validation Error Message */}
                      {hasChanges && editedData.start_time && editedData.end_time && 
                       moment(editedData.end_time).isSameOrBefore(moment(editedData.start_time)) && (
                        <div style={{ 
                          color: '#d32f2f', 
                          fontSize: '14px', 
                          padding: '8px 12px',
                          backgroundColor: '#ffebee',
                          borderRadius: '4px',
                          border: '1px solid #ef5350'
                        }}>
                          End time must be after start time
                        </div>
                      )}
                      
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                        <Button
                          primary={true}
                          disabled={
                            !hasChanges || 
                            loadingEventDetails || 
                            (editedData.start_time && editedData.end_time && 
                             moment(editedData.end_time).isSameOrBefore(moment(editedData.start_time)))
                          }
                          onClick={async () => {
                            if (!selectedEventData?.event_id) return;
                            
                            // Validate times
                            if (editedData.start_time && editedData.end_time) {
                              if (moment(editedData.end_time).isSameOrBefore(moment(editedData.start_time))) {
                                alert('End time must be after start time.');
                                return;
                              }
                            }
                            
                            setLoadingEventDetails(true);
                            try {
                              // Format times to HH:mm:ss
                              const formattedStartTime = editedData.start_time
                                ? moment(editedData.start_time).format('HH:mm:ss')
                                : (selectedEventData.start_time || null);
                              
                              const formattedEndTime = editedData.end_time
                                ? moment(editedData.end_time).format('HH:mm:ss')
                                : (selectedEventData.end_time || null);
                              
                              // Format date to YYYY-MM-DD
                              const formattedStartDate = selectedEventData.start_date 
                                ? moment(selectedEventData.start_date).format('YYYY-MM-DD')
                                : '';
                              
                              // Map location_type to valid backend values
                              const mapLocationType = (location: string | undefined): string => {
                                if (!location) return '';
                                // Map "The Organization" to "The School" for backend compatibility
                                if (location === 'The Organization') {
                                  return 'The School';
                                }
                                // Return as-is if already valid
                                return location;
                              };
                              
                              const updateData = {
                                location_type: mapLocationType(selectedEventData.location),
                                address: selectedEventData.resolved_address?.address || selectedEventData.address || '',
                                city: selectedEventData.resolved_address?.city || selectedEventData.city || '',
                                state: selectedEventData.resolved_address?.state || selectedEventData.state || '',
                                zip_code: selectedEventData.resolved_address?.zip_code || selectedEventData.zip_code || '',
                                start_date: formattedStartDate,
                                end_date: formattedStartDate, // Using same date for end_date
                                start_time: formattedStartTime,
                                end_time: formattedEndTime,
                              };

                              console.log('[EventsScreen] Saving event time data:', updateData);
                              const response: any = await d4ur.updateEventLocationDate(
                                selectedEventData.event_id,
                                updateData
                              );

                              if (response?.result?.success) {
                                console.log('[EventsScreen] Successfully updated event times');
                                alert('Event times updated successfully!');
                                
                                // Refresh the event details
                                await handleViewEventDetails(selectedEventData.event_id);
                                setIsEditing(false);
                                setHasChanges(false);
                                
                                // Refresh the events list
                                d4ur.getEvents().then((ret) => {
                                  const processedEvents = processEvents(
                                    (ret as D4URFetchResult).result || []
                                  );
                                  ui.setEvents(processedEvents);
                                });
                              } else {
                                console.error('[EventsScreen] Error updating event:', response);
                                alert(response?.result?.error || 'Failed to update event times. Please try again.');
                              }
                            } catch (error) {
                              console.error('[EventsScreen] Error updating event:', error);
                              alert('Failed to update event times. Please try again.');
                            } finally {
                              setLoadingEventDetails(false);
                            }
                          }}
                          style={{
                            backgroundColor: (hasChanges && !loadingEventDetails && 
                              !(editedData.start_time && editedData.end_time && 
                                moment(editedData.end_time).isSameOrBefore(moment(editedData.start_time)))) 
                              ? '#00095B' : '#ccc',
                            cursor: (hasChanges && !loadingEventDetails && 
                              !(editedData.start_time && editedData.end_time && 
                                moment(editedData.end_time).isSameOrBefore(moment(editedData.start_time)))) 
                              ? 'pointer' : 'not-allowed'
                          }}
                        >
                          {loadingEventDetails ? 'Saving...' : 'Save'}
                        </Button>
                        <div style={{ 
                          fontSize: '12px', 
                          color: '#d32f2f',
                          marginTop: '4px'
                        }}>
                          For any other changes to event details, please contact PHQ at{' '}
                          <a 
                            href="mailto:hello@driveforyourcommunity.com" 
                            style={{ 
                              color: '#0066cc',
                              textDecoration: 'underline',
                              fontSize: '12px',
                            }}
                          >
                            hello@driveforyourcommunity.com
                          </a>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <div>
                  <div style={{ 
                    fontSize: '12px', 
                    color: '#666', 
                    fontWeight: 600, 
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    marginBottom: '8px' 
                  }}>
                    Event End Time
                  </div>
                  {isEditing && isEventEditable(selectedEventData) ? (
                    <TimePicker
                      value={editedData.end_time}
                      onChange={(e) => {
                        setEditedData({...editedData, end_time: e.value});
                        setHasChanges(true);
                      }}
                      format="h:mm a"
                    />
                  ) : (
                    <div style={{ fontSize: '16px', color: '#333', fontWeight: 500 }}>
                      {selectedEventData.end_time ? moment(selectedEventData.end_time, 'HH:mm:ss').format('h:mm A') : 'N/A'}
                    </div>
                  )}
                </div>
              </div>
            </div>

            {/* Location Section */}
            <div style={{ 
              backgroundColor: '#FFFFFF',
              borderRadius: '8px',
              padding: '15px',
              marginBottom: '15px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}>
              <h3 style={{ 
                margin: '0 0 15px 0', 
                color: '#00095B',
                fontSize: '18px',
                fontWeight: 600,
                borderBottom: '2px solid #00095B',
                paddingBottom: '8px'
              }}>
                Location
              </h3>
              
              {/* Location Type */}
              <div style={{ marginBottom: '15px' }}>
                <div style={{ 
                  fontSize: '12px', 
                  color: '#666', 
                  fontWeight: 600, 
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  marginBottom: '8px' 
                }}>
                  Location Type
                </div>
                <div style={{ fontSize: '16px', color: '#333', fontWeight: 500 }}>
                  {selectedEventData.location || 'N/A'}
                </div>
              </div>

              {/* Address Fields */}
              <div>
                <div style={{ 
                  fontSize: '12px', 
                  color: '#666', 
                  fontWeight: 600, 
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px',
                  marginBottom: '8px' 
                }}>
                  Address
                </div>
                <div style={{ fontSize: '16px', color: '#333', fontWeight: 500, lineHeight: '1.5' }}>
                  {selectedEventData.resolved_address?.address || selectedEventData.address || 'N/A'}
                  {(selectedEventData.resolved_address?.city || selectedEventData.city) && 
                    `, ${selectedEventData.resolved_address?.city || selectedEventData.city}`}
                  {(selectedEventData.resolved_address?.state || selectedEventData.state) && 
                    `, ${selectedEventData.resolved_address?.state || selectedEventData.state}`}
                  {(selectedEventData.resolved_address?.zip_code || selectedEventData.zip_code) && 
                    ` ${selectedEventData.resolved_address?.zip_code || selectedEventData.zip_code}`}
                </div>
              </div>
            </div>

            {/* Benefitting Section */}
            <div style={{ 
              backgroundColor: '#FFFFFF',
              borderRadius: '8px',
              padding: '15px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
            }}>
              <h3 style={{ 
                margin: '0 0 15px 0', 
                color: '#00095B',
                fontSize: '18px',
                fontWeight: 600,
                borderBottom: '2px solid #00095B',
                paddingBottom: '8px'
              }}>
                Benefitting
              </h3>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                <div>
                  <div style={{ 
                    fontSize: '12px', 
                    color: '#666', 
                    fontWeight: 600, 
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    marginBottom: '8px' 
                  }}>
                    Charity Partner
                  </div>
                  <div style={{ fontSize: '16px', color: '#333', fontWeight: 500 }}>
                    {selectedEventData.charity_partner || 'N/A'}
                  </div>
                </div>
                <div>
                  <div style={{ 
                    fontSize: '12px', 
                    color: '#666', 
                    fontWeight: 600, 
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    marginBottom: '8px' 
                  }}>
                    Additional School Name
                  </div>
                  <div style={{ fontSize: '16px', color: '#333', fontWeight: 500 }}>
                    {selectedEventData.secondary_charity || 'N/A'}
                  </div>
                </div>
                <div>
                  <div style={{ 
                    fontSize: '12px', 
                    color: '#666', 
                    fontWeight: 600, 
                    textTransform: 'uppercase',
                    letterSpacing: '0.5px',
                    marginBottom: '8px' 
                  }}>
                    Check Payable
                  </div>
                  <div style={{ fontSize: '16px', color: '#333', fontWeight: 500 }}>
                    {selectedEventData.check_payable || 'N/A'}
                  </div>
                </div>
              </div>
            </div>
          </div>
          ) : (
            <div style={{ textAlign: "center", padding: "40px" }}>
              <p>No event details available.</p>
            </div>
          )}
          <DialogActionsBar>
            <Button onClick={() => setEventDetailsDialogDisplayed(false)}>
              Close
            </Button>
          </DialogActionsBar>
        </Dialog>
      )}
      {dialogDisplayed && (
        <Dialog>
          <h3>Submit Event Reimbursement</h3>

          <p>
            Upload receipts and estimated attendance to PHQ for final approval.
          </p>
          <Form
            onSubmit={onSubmitReimbursement}
            render={(formRenderProps) => (
              <FormElement horizontal={true}>
                {formError && <Error>{formError}</Error>}
                <Field
                  id={"attendance"}
                  name={"attendance"}
                  // type={'input'}
                  label={localizationService.toLanguageString(
                    "custom.attendance",
                    "attendance"
                  )}
                  childRef={ref}
                  // validator={requiredValidator}
                  component={NumericTextBox}
                />
                <Field
                  id={"event_reimbursement_file"}
                  name={"event_reimbursement_file"}
                  type={"file"}
                  multiple={false}
                  files={files}
                  onAdd={onAdd}
                  onRemove={onRemove}
                  onProgress={onProgress}
                  onStatusChange={onStatusChange}
                  onChange={() => (formRenderProps.allowSubmit = true)}
                  label={localizationService.toLanguageString(
                    "custom.event_reimbursement_file",
                    "event_reimbursement_file"
                  )}
                  hint={localizationService.toLanguageString(
                    "custom.event_reimbursement_file_hint",
                    "event_reimbursement_file_hint"
                  )}
                  // validator={requiredValidator}
                  component={Upload}
                />
                <DialogActionsBar>
                  <Button
                    primary={true}
                    type={"submit"}
                    disabled={!formRenderProps.allowSubmit}
                  >
                    {localizationService.toLanguageString(
                      "custom.request_reimbursement",
                      "request_reimbursement"
                    )}
                  </Button>
                </DialogActionsBar>
              </FormElement>
            )}
          />
        </Dialog>
      )}
      {twoFA_DialogDisplayed && (
        <Dialog style={{ width: "50%", marginLeft: "25%" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <h3>Two-Factor Authentication Required</h3>
            <Button
              style={{
                marginLeft: 30,
                color: "#ff6358",
                backgroundColor: "transparent",
              }}
              onClick={() => {
                setTwoFA_DialogDisplayed(false);
                setTwoFAEmailSent(false);
              }}
            >
              Cancel
            </Button>
          </div>
          <p style={{ textAlign: "center" }}>
            {twoFAEmailSent
              ? 'Please check your email for the 2FA code. Enter it below and then press "Authenticate."'
              : 'To view the list of event respondents, select "Send 2FA Email" below to send a code to you via email. Then, you will be prompted to enter that code to authenticate the respondents page.'}
          </p>
          <Button
            style={{ marginBottom: 5, width: "40%", marginLeft: "30%" }}
            onClick={handleSend2FAEmail}
            hidden={twoFAEmailSent}
          >
            {"Send 2FA Email"}
          </Button>
          {twoFAEmailSent ? (
            <Form
              onSubmit={onSubmit2FACode}
              render={() => (
                <FormElement
                  horizontal={true}
                  style={{
                    width: "60%",
                    marginLeft: "20%",
                    marginBottom: 10,
                    marginTop: 15,
                  }}
                >
                  {formError && <Error>{formError}</Error>}
                  <Field
                    id={"entered_code"}
                    name={"entered_code"}
                    label={"2FA Code"}
                    component={Input}
                  />
                  <Button
                    primary={true}
                    type={"submit"}
                    style={{ marginTop: 10, width: "100%" }}
                  >
                    Authenticate
                  </Button>
                  {twoFAError ? (
                    <Button
                      style={{
                        backgroundColor: "transparent",
                        borderWidth: 0,
                        width: "40%",
                        marginLeft: "30%",
                        cursor: "pointer",
                      }}
                      onClick={handleSend2FAEmail}
                      hidden={!twoFAEmailSent}
                    >
                      <p
                        style={{
                          color: "red",
                          fontSize: 15,
                          cursor: "pointer",
                        }}
                      >
                        {twoFAError}
                      </p>
                    </Button>
                  ) : null}
                </FormElement>
              )}
            />
          ) : null}
        </Dialog>
      )}
      <div id="Dashboard" className="events_page">
        {/* <div className='min-height'> */}
        <div className="grid_container">
          <div className="container_header">
            <p className="card-title">
              {login.dealer?.dealer_name}:{" "}
              {localizationService.toLanguageString("custom.events", "events")}
            </p>
            <div className="btn_container">
              {renderEventRequestButton(login.dealer as Dealer)}
              {/* {!ui.eventsFull || hasAnEvent || login.dealer?.invited_off_waitlist ? (
                <>
                  <Button
                    primary={!hasAnEvent}
                    onClick={handleEventRequestButton}
                    className="standard_btn wide"
                    disabled={hasAnEvent}
                    // disabled={true}
                  >
                    {hasAnEvent || ui.events.length
                      ? localizationService.toLanguageString(
                        "custom.requestNewEvent",
                        "requestNewEvent"
                      )
                      : localizationService.toLanguageString(
                        "custom.beginHere",
                        "beginHere"
                      )}
                  </Button>
                </>
              ) : (
                <>
                  <Button
                    primary={!hasAnEvent}
                    onClick={handleJoinWaitlistButton}
                    className="standard_btn wide"
                    // disabled={login.dealer?.waitlisted ? true : false}
                    disabled={true}
                  >
                    {login.dealer?.waitlisted ? 'Waitlist Joined' : 'Join Waitlist'}
                  </Button>
                </>
              )} */}
              {generateHelperText(login.dealer as Dealer)}
            </div>
          </div>
          <br />
          {processing ? (
            <div style={{ textAlign: "center" }}>
              <Loader type="infinite-spinner" size="large" />
            </div>
          ) : (
            <div className="card-component">
              <Grid data={ui.events} scrollable="none">
                <GridColumn field="charity_partner" title="Organization" />
                <GridColumn
                  cell={EventStatusCell}
                  field="status"
                  title="Status"
                />
                <GridColumn field="display_date" title="Event Date" />
                <GridColumn cell={EventActionsCell} />
              </Grid>
            </div>
          )}
        </div>
      </div>
      {/* </div> */}
      <PrivacyBanner
        containerStyle={{ padding: "10px 0 0", width: "100%" }}
        privacyContainerStyle={{
          padding: "10px 0",
          width: "60%",
          marginLeft: "20%",
        }}
        showPrivacy={true}
        language={language}
        team={"ford"}
        imgStyle={{ paddingLeft: "30px" }}
        otherLinks={[
          { text: "CONTACT US", url: "/contact", target: "_blank" },
          {
            text: "PROGRAM TERMS AND CONDITIONS",
            url: "/terms-eligibility",
            target: "_blank",
          },
          { text: "PROGRAM RESOURCES ", url: "/resources", target: "_blank" },
        ]}
      />
    </>
  );
};

export default observer(EventsScreen);
